const SEASON_IMAGES = {
  spring:
    "https://images.unsplash.com/photo-1605528017351-8635bb3d6a3a?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
  summer:
    "https://images.unsplash.com/photo-1497211419994-14ae40a3c7a3?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
  fall: "https://images.unsplash.com/photo-1501973801540-537f08ccae7b?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
  winter:
    "https://images.unsplash.com/photo-1617509309193-d66980387982?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80",
};

// Northern Hemisphere: Mar-May spring, Jun-Aug summer, Sep-Nov fall, Dec-Feb winter
export const getSeason = (date = new Date()) => {
  const m = date.getMonth();
  if (m >= 2 && m <= 4) return "spring";
  if (m >= 5 && m <= 7) return "summer";
  if (m >= 8 && m <= 10) return "fall";
  return "winter";
};

export const Hero = () => {
  const season = getSeason();
  return (
    <section
      id="top"
      data-testid="hero-section"
      data-season={season}
      className="relative overflow-hidden px-6 pt-32 pb-16 sm:pt-40 sm:pb-20"
    >
      <img
        src={SEASON_IMAGES[season]}
        alt=""
        aria-hidden="true"
        data-testid="hero-background-image"
        className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none"
      />
      <div className="absolute inset-0 bg-[#F7F4EE]/80" aria-hidden="true" />
      <div className="relative max-w-5xl mx-auto">
        <p
          data-testid="hero-dateline"
          className="font-mono text-sm sm:text-base tracking-[0.25em] uppercase text-mutedink mb-5"
        >
          Hailey and Chloe Holdings Inc.
        </p>
        <h1 className="font-serif font-light tracking-tight text-ink text-2xl sm:text-3xl lg:text-4xl leading-[1.15] max-w-2xl">
          Clothing Ideas Around us.{" "}
          <span className="italic text-oxblood">
            Building Communities One at Time.
          </span>
        </h1>
        <p
          data-testid="hero-subtitle"
          className="mt-6 max-w-xl text-base font-light text-[#2A2A2A] leading-relaxed"
        >
          We invest in and grow apparel businesses across activewear,
          streetwear, and childrenswear. Below is our current portfolio.
        </p>
      </div>
    </section>
  );
};
